exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jw-video-thumbnail,\n.jw-video-thumbnail-container {\n  width: 100%;\n  height: 100%;\n}\n.overlay__fullscreen {\n  background-color: rgb(112, 186, 247);\n  color: white;\n  width: 44px;\n  height: 44px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top-left-radius: 5px;\n  z-index: 10;\n}\n.overlay__fullscreen:hover {\n  background-color: rgba(112, 186, 247, 0.8);\n  cursor: pointer;\n}\n.vertical .jw-video-thumbnail-generated {\n  display: none;\n}", ""]);

// exports
